import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { Home as HomeIcon, Sun } from 'lucide-react';
import Home from './pages/Home';
import WillametteHS from './pages/WillametteHS';
import KalapuyaCTE from './pages/KalapuyaCTE';
import KalapuyaHS from './pages/KalapuyaHS';
import CascadeMS from './pages/CascadeMS';
import './App.css';

const Navigation = () => {
  const location = useLocation();
  const isHome = location.pathname === '/';

  if (isHome) return null;

  return (
    <div className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-3">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-blue-600 hover:text-blue-700 transition-colors">
            <HomeIcon className="w-5 h-5" />
            <span className="font-medium">Back to All Sites</span>
          </Link>
          <div className="flex items-center gap-2">
            <Sun className="w-5 h-5 text-yellow-500" />
            <span className="text-gray-700 font-medium">Bethel Solar Dashboard</span>
          </div>
        </div>
      </div>
    </div>
  );
};

function App() {
  return (
    <Router>
      <Navigation />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/willamette" element={<WillametteHS />} />
        <Route path="/kalapuya-cte" element={<KalapuyaCTE />} />
        <Route path="/kalapuya-hs" element={<KalapuyaHS />} />
        <Route path="/cascade-ms" element={<CascadeMS />} />
      </Routes>
    </Router>
  );
}

export default App;
